
import { reactive, computed } from 'vue'

// Dati piano iniettati dal Blade layout via window.__PLAN__
const state = reactive({
    codice: window.__PLAN__?.codice ?? 'essentials',
    features: window.__PLAN__?.features ?? {},
})

export function usePlan() {
    const planCode = computed(() => state.codice)
    const features = computed(() => state.features)

    /**
     * Controlla se una feature booleana e' abilitata.
     */
    function can(featureKey) {
        const value = state.features[featureKey]
        return ['true', 'unlimited', 'included', 'advanced'].includes(value)
    }

    /**
     * Ottieni il limite numerico. Restituisce null se unlimited.
     */
    function limit(featureKey) {
        const value = state.features[featureKey]
        if (value === 'unlimited') return null
        return parseInt(value, 10) || 0
    }

    /**
     * Ottieni il livello testuale (es. 'base', 'advanced').
     */
    function level(featureKey) {
        return state.features[featureKey] ?? 'false'
    }

    /**
     * Check se il piano corrente e' almeno il livello specificato.
     */
    function isAtLeast(requiredPlan) {
        const order = { essentials: 1, professional: 2, enterprise: 3 }
        return (order[planCode.value] ?? 0) >= (order[requiredPlan] ?? 0)
    }

    /**
     * Aggiorna i dati piano (utile dopo un upgrade senza reload pagina).
     */
    async function refresh() {
        try {
            const { data } = await axios.get('/api/plan')
            state.codice = data.codice
            state.features = data.features
        } catch (e) {
            console.error('Errore aggiornamento piano:', e)
        }
    }

    return {
        planCode,
        features,
        can,
        limit,
        level,
        isAtLeast,
        refresh,
    }
}